Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.CopySessionView extends Backbone.View
  template: JST['backbone/templates/monitoring/sessions/copy_session_modal']

  initialize: (@options = {}) ->
    @session = @options.session
    @replaceSession = false

  toggleReplaceSession: (evt) ->
    evt.preventDefault()
    @replaceSession = !@replaceSession

  render: ->
    @_bindCloseModalEvent()
    @$el.html(@template({users: @options.users}))
    @$el.find('#copy_session #done').on('click', @onDone)
    @$el.find('#replace_session').on('click', () => @toggleReplaceSession(evt))
    @_initializeEmptyAutocomplete()
    @$el.find('.users').html(@keywordsView.render().el)
    @

  _initializeEmptyAutocomplete: ->
    users = []
    keywords = new Monitoring.Collections.KeywordsCollection()
    @keywordsView = new Monitoring.Views.KeywordView
      keywords: keywords
      allowedKeywords: []
      placeholder: I18n.t('monitoring.dashboard.session.tab.enter_email')
      autoComplete: []
    @keywordsView.bind('on_keypress', @onTypeCharacter)

  onTypeCharacter: (event) =>
    text = @keywordsView.written_text()
    if text.length >= 3 && text.substring(0, 3) != @firstFour
      @firstFour = text.substring(0, 3)
      @_availableUsersMatching(text)
    else if text.length == 0 && @firstFour != undefined
      @firstFour = undefined
      @updateUsers([])

  updateUsers: (users_info) ->
    @users = _.reject(users_info.users, (user) -> Keepcon.currentUser.id == user.id)
    allowedKeywords = _.map(@users, (user) -> {name: user.name_and_email})
    autoComplete = {keywords: _.pluck(@users, 'name_and_email')}
    @keywordsView.updateKeywords(allowedKeywords, autoComplete)

  _availableUsersMatching: (text) ->
    $.ajax
      url: "/api/users/users_matching"
      type: 'GET'
      contentType: 'application/json; charset=utf-8',
      data:
        matching_text: text
      dataType: 'json',
      success: (response) =>
        @updateUsers(response)

  show: ->
    @$el.find('#copy_session').modal()

  clear: ->
    @$el.find('#copy_session').modal('hide')

  onDone: =>
    @_allUsers((allUsers) =>
      users = _.filter(@_getUsers(allUsers), (option) -> option.subject_type == "Keepcon::User")
      if users.length == 0
        showError('You must select at least one user')
        return
      users_ids = _.map(users, (user) -> user.id || user.subject_id)
      $.ajax
        url: "/monitoring/sessions/#{@session.uuid}/copy"
        data: JSON.stringify({
          users_ids: users_ids
          replace_session: @replaceSession
        })
        type: 'POST'
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success: (response) =>
          @trigger('onSuccess', response)
    )

  _getUsers: (allUsers) ->
    users = _.map(@keywordsView.getKeywordsAttributes(), (attr) =>
      attr.subject_id = _.find(allUsers, (user) -> user.name_and_email == attr.name).id
      attr.subject_type = 'Keepcon::User'
      delete (attr.name)
      attr)
    users.push({
      subject_id: Keepcon.currentAccount.id
      subject_type: 'Keepcon::Account'
      id: @$el.find('#replace_session_at_copy').data('id')
      _destroy: !@$el.find('#replace_session_at_copy').prop('checked')
    })
    return users

  _allUsers: (onSuccess) ->
    $.ajax
      url: "/api/users/users_matching"
      type: 'GET'
      contentType: 'application/json; charset=utf-8',
      async: false,
      data:
        matching_text: ''
      dataType: 'json'
      success: (response) =>
        onSuccess(response.users)

  _bindCloseModalEvent: ->
    @$el.on('hide.bs.modal', () ->
      setTimeout () ->
        Backbone.trigger('copySessionModal:closed')
      , 200
    )
